import { observer } from 'mobx-react-lite';
import React from 'react';
import rootStyles from '../../index.module.scss';
import classNames from 'classnames';
import { ISurgeryInfo } from '../../../../../../../../../services/intakeDataService/types';
import useIntakeBlockToggle, { intakeBlocksEnum } from '../../../../../hooks/useIntakeBlockToggle';
import SurgeryFields from './SurgeryFields';
import styles from '../index.module.scss';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { Button } from '@mui/material';

const SurgeriesInformation = () => {
  const { isOn } = useIntakeBlockToggle();
  const { control, watch } = useFormContext();
  const { fields, remove, append, update } = useFieldArray({
    control,
    name: 'surgeries',
  });

  const onRemove = (index: number) => {
    const surgeryToRemoveIndex = fields.findIndex((_, fieldIndex) => fieldIndex === index);
    if (surgeryToRemoveIndex !== -1) {
      remove(surgeryToRemoveIndex);
    }
  };

  const getSurgery = (index: number) => watch('surgeries')[index] as unknown as ISurgeryInfo;

  const onAdd = () => {
    append({ surgeryType: '', surgeryDate: '' });
  };

  const onUpdate = (target: HTMLInputElement, index: number) => {
    const surgeryToUpdateIndex = fields.findIndex((_, fieldIndex) => fieldIndex === index);
    if (surgeryToUpdateIndex !== -1) {
      update(surgeryToUpdateIndex, {
        ...getSurgery(surgeryToUpdateIndex),
        [target.name as 'surgeryType' | 'surgeryDate']: target.value,
      });
    }
  };

  if (!isOn(intakeBlocksEnum.surgery)) {
    return null;
  }

  return (
    <div className={classNames('flex flex-col', rootStyles.gap)}>
      {(fields as unknown as ISurgeryInfo[]).map((surgery: ISurgeryInfo, index: number) => (
        <div
          key={`surgery-${index}-${surgery.id}`}
          className={classNames('flex flex-col', rootStyles.gap)}
        >
          <SurgeryFields
            surgeryIndex={index}
            surgery={getSurgery(index)}
            onRemove={onRemove}
            onUpdate={onUpdate}
          />
          {index === fields.length - 1 ? (
            <Button
              variant={'text'}
              color="primary"
              className={classNames(styles.actionBtn, styles.add)}
              onClick={onAdd}
            >
              + Add Surgery
            </Button>
          ) : null}
        </div>
      ))}
    </div>
  );
};
export default observer(SurgeriesInformation);
